import { apiRequest } from 'api/apiClient';
import refreshTokenClient from 'api/refreshTokenClient';

const login = async ({ email, password }) => {
  const response = await apiRequest('POST', '/v1/auth/login', { email, password });
  return response;
};

const logout = async () => {
  const response = await refreshTokenClient.post('/v1/auth/logout', {});
  return response.data;
};

const register = async ({ email, password, name, last_name }) => {
  const response = await apiRequest('POST', '/v1/users/admin-sign-up', {
    email,
    password,
    name,
    last_name,
  });
  return response;
};

const activateAccount = async ({ email, password, verification_code, name, last_name }) => {
  const response = await apiRequest('POST', '/v1/users/retailer-sign-up', {
    email,
    password,
    verification_code,
    name,
    last_name,
  });
  return response;
};

const sendResetPasswordCode = async ({ email }) => {
  const response = await apiRequest('POST', '/v1/users/reset-password-code', { email });
  return response;
};

const resetPassword = async ({ password, reset_password_code }) => {
  const response = await apiRequest('POST', '/v1/users/reset-password', {
    password,
    reset_password_code,
  });
  return response;
};

const deleteMe = async () => {
  const response = await apiRequest('DELETE', '/v1/users/me');
  return response;
};

const AUTH_MUTATIONS = {
  LOGIN: login,
  LOGOUT: logout,
  REGISTER: register,
  ACTIVATE_ACCOUNT: activateAccount,
  SEND_RESET_PASSWORD_CODE: sendResetPasswordCode,
  RESET_PASSWORD: resetPassword,
  DELETE_ME: deleteMe,
};

export default AUTH_MUTATIONS;
